// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import "./railsui";
import { application } from "./application";

import HelloController from "./hello_controller";
import radio_select_controller from "./radio_select_controller";
import toggle_element_controller from "./toggle_element_controller";
import switch_elements_controller from "./approval/switch_elements_controller";
import website_email_controller from "./approval/website_email_controller";
import paddle_controller from "./paddle_controller";
import toggle_plan_controller from "./billing/toggle_plan_controller";
import pricing_item_controller from "./billing/pricing_item_controller";
import dropzone_controller from "./dropzone_controller";
import coloris_controller from "./coloris_controller";
import select_controller from "./select_controller";
import Clipboard from "@stimulus-components/clipboard";
import autofocus_controller from "./autofocus_controller";
import token_controller from "./token_controller";
import filter_controller from "./filter_controller";
import filter_rule_controller from "./filter_rule_controller";
import rules_controller from "./rules_controller";
import FiltersController from './filters_controller.js'
import EditorController from "./editor_controller";
import GrapejsController from "./grapejs_controller";

application.register("hello", HelloController);
application.register("radio-select", radio_select_controller);
application.register("toggle-element", toggle_element_controller);
application.register("approval-switch-elements", switch_elements_controller);
application.register("approval-website-email", website_email_controller);
application.register('paddle', paddle_controller)
application.register('toggle-plan', toggle_plan_controller)
application.register('pricing-item', pricing_item_controller)
application.register('dropzone', dropzone_controller)
application.register('coloris', coloris_controller)
application.register('select', select_controller)
application.register("clipboard", Clipboard);
application.register('autofocus', autofocus_controller)
application.register('token', token_controller)
application.register('filter', filter_controller)
application.register("filter-rule", filter_rule_controller)
application.register('rules', rules_controller)
application.register("filters", FiltersController)
application.register("editor", EditorController)
application.register("grapejs", GrapejsController)
